"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authorization = void 0;
var auth_custom_1 = require("./auth.custom");
var auth_token_1 = require("./auth.token");
var auth_apikey_1 = require("./auth.apikey");
var auth_basic_1 = require("./auth.basic");
var Authorization = (function () {
    function Authorization() {
    }
    Authorization.prototype.updateFromValue = function (auth) {
        var pieces = auth.split(' ');
        if (pieces.length !== 2) {
            if (auth.length > 0) {
                this.method = new auth_custom_1.AuthCustom(auth);
                return undefined;
            }
            return new Error('authorization update expects "type value" format, got ' + auth);
        }
        switch (pieces[0].toLowerCase()) {
            case 'bearer':
                this.method = new auth_token_1.AuthToken(pieces[1]);
                break;
            case 'apikey':
            case 'api-key':
                this.method = new auth_apikey_1.AuthApiKey(pieces[1]);
                break;
            case 'basic':
                {
                    var basic = new auth_basic_1.AuthBasic();
                    basic.fromValue(pieces[1]);
                    this.method = basic;
                }
                break;
            default:
                this.method = new auth_custom_1.AuthCustom(auth);
        }
        return undefined;
    };
    Authorization.prototype.toValue = function () {
        if (!this.method) {
            return '';
        }
        return this.method.toValue();
    };
    return Authorization;
}());
exports.Authorization = Authorization;
//# sourceMappingURL=auth.js.map